import EmployeeSidebar from "../../../Components/Dashboard/Employee/EmployeeSidebar";
import SideNav from "../../../Components/Dashboard/Employee/EditEmployee/SideNav";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import EmployeDocForm from "../../../Components/Dashboard/Employee/EditEmployee/Form/EmployeDocForm";

export default function EmployeeDocument() {
  const navigate = useNavigate();

  

  return (
    <>
      <div className="aside-collapsed">
        <div className="wrapper">
          <EmployeeSidebar />
          <section>
            <div
              className="content-wrapper"
              style={{ backgroundColor: "#ecf0f5" }}
            >
              <div class="content-heading">
                Employee Documents Information
                <div class="pull-right">
                  <Button
                    class="btn btn-primary btn-square pull-right"
                    onClick={() => navigate(-1)}
                  >
                    BACK
                  </Button>
                </div>
              </div>

              <div class="row d-flex">
                <SideNav />
                <EmployeDocForm />
              </div>
            </div>
          </section>

          <footer>
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12">
                <a href="##" data-toggle="modal" data-target="#termsOfUse">
                  Terms of use of ShiftSecure
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
}
